{
  "name": "rsa-front",
  "version": "5.14.6",
  "scripts": {
    "ng": "ng",
    "dev": "ng serve",
    "start:docker": "ng serve --host 0.0.0.0 --disable-host-check --poll 500",
    "start:prod": "ng serve --prod",
    "build": "ng build",
    "build:prod": "ng build --configuration production",
    "lint": "ng lint",
    "e2e": "ng e2e",
    "format-all": "prettier --write \"src/**/*.ts\"",
    "tslint-check": "tslint-config-prettier-check ./tslint.json",
    "test": "jest",
    "test:all": "node --expose-gc ./node_modules/.bin/jest --runInBand --logHeapUsage # limit Jest memory usage",
    "test:clear": "jest --clearCache",
    "test:watch": "jest --watch",
    "test:ci": "jest --runInBand",
    "test:export": "jest --reporters=\"./src/jest-csv-reporter\"",
    "test:cov": "jest --coverage",
    "show:log": "docker logs insertis-front-1 -f",
    "release": "standard-version"
  },
  "jest": {
    "preset": "jest-preset-angular",
    "setupFilesAfterEnv": [
      "<rootDir>/src/jest-setup.ts"
    ]
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^18.2.11",
    "@angular/cdk": "^18.2.12",
    "@angular/common": "^18.2.11",
    "@angular/compiler": "^18.2.11",
    "@angular/core": "^18.2.11",
    "@angular/forms": "^18.2.11",
    "@angular/localize": "^18.2.11",
    "@angular/material": "^18.2.12",
    "@angular/platform-browser": "^18.2.11",
    "@angular/platform-browser-dynamic": "^18.2.11",
    "@angular/router": "^18.2.11",
    "@fortawesome/angular-fontawesome": "^0.15.0",
    "@fortawesome/fontawesome-svg-core": "^6.6.0",
    "@fortawesome/free-regular-svg-icons": "^6.6.0",
    "@fortawesome/free-solid-svg-icons": "^6.6.0",
    "@ng-bootstrap/ng-bootstrap": "^17.0.1",
    "@ng-select/ng-select": "^13.9.1",
    "angular-calendar": "^0.31.1",
    "bootstrap": "^5.3.3",
    "core-js": "^3.39.0",
    "crypto-js": "^4.2.0",
    "file-saver": "^2.0.5",
    "moment": "^2.30.1",
    "ngx-quill": "^26.0.9",
    "numeral": "2.0.6",
    "quill": "2.0.2",
    "quill-image-resize-module": "3.0.0",
    "rxjs": "^7.8.1",
    "signature_pad": "^5.0.4",
    "standard-version": "^9.5.0",
    "ts-cacheable": "^1.0.10",
    "tslib": "^2.8.1",
    "zone.js": "^0.14.10"
  },
  "devDependencies": {
    "@angular/build": "^18.2.11",
    "@angular/cli": "^18.2.11",
    "@angular/compiler-cli": "^18.2.11",
    "@angular/language-service": "^18.2.11",
    "@types/crypto-js": "^4.2.2",
    "@types/jest": "^29.5.14",
    "@types/node": "^22.9.0",
    "eslint": "^9.14.0",
    "jest": "^29.7.0",
    "jest-preset-angular": "^14.2.4",
    "jquery": "^3.7.1",
    "npm-run-all": "4.1.5",
    "prettier": "^3.3.3",
    "ts-jest": "^29.2.5",
    "ts-mockito": "^2.6.1",
    "typescript": "^5.5.4"
  },
  "browser": {
    "crypto": false
  }
}
